module.exports = "//public.zight.com/packs/media/images/download-chrome-c1e89ede4a531dd325863cb999407114.svg";